import { ReactIdSwiperProps, ReactIdSwiperRenderProps } from '@yanolja-org/react-swiper';
import clsx from 'clsx';
import { nextButton, prevButton, renewalNextButton, renewalPrevButton } from './SwiperNavs';
import navStyles from './SwiperNavs.module.scss';
import { isWeb as checkWeb } from '@/utils';
import { useEffect, useState } from 'react';

type NavigationOptions = {
  itemType?: string;
  isRenewal?: boolean;
  navigation: ReactIdSwiperProps['navigation'];
};

const useNavigation = ({
  itemType,
  isRenewal,
  navigation,
}: NavigationOptions): {
  prevBtn: ReactIdSwiperRenderProps | undefined;
  nextBtn: ReactIdSwiperRenderProps | undefined;
  navigationConfig: ReactIdSwiperProps['navigation'];
} => {
  const [isWeb, setIsWeb] = useState<boolean>(true);
  useEffect(() => {
    setIsWeb(checkWeb());
  }, []);
  const prevClassName = navigation?.prevEl && String(navigation.prevEl).replace('.', '');
  const nextClassName = navigation?.nextEl && String(navigation.nextEl).replace('.', '');

  const navigationConfig = isWeb
    ? {
        prevEl: `.${prevClassName ? prevClassName : navStyles.prevButton}`,
        nextEl: `.${nextClassName ? nextClassName : navStyles.nextButton}`,
      }
    : {};

  const buttonClassName = itemType === 'banner' ? navStyles.banner : undefined;
  const prevBtn = isRenewal
    ? renewalPrevButton(clsx(prevClassName, isWeb && navStyles.displayedNav))
    : itemType !== 'tab'
    ? prevButton(clsx(buttonClassName, navStyles.prevButton, prevClassName && prevClassName))
    : undefined;
  const nextBtn = isRenewal
    ? renewalNextButton(clsx(nextClassName, isWeb && navStyles.displayedNav))
    : itemType !== 'tab'
    ? nextButton(clsx(buttonClassName, navStyles.nextButton, nextClassName && nextClassName))
    : undefined;

  return {
    navigationConfig,
    prevBtn,
    nextBtn,
  };
};

export default useNavigation;
